export default __webpack_public_path__ + "static/great-smoky-mountains-national-park-b6496aa23f85e43c827ee95b01f5d38b.png";